<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
    <back-to-top>
      <p class="back-to-top flex-middle">
        <!-- <b-icon pack="fas" icon="arrow-up" ></b-icon> -->
        <i class="fas fa-arrow-up" title="Back to top" style="font-size: 20px;"></i>
      </p>
    </back-to-top>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
    
  }
}
</script>

<style lang="scss">
.color-sky-blue{
  color:#4BE4FF;
}
a.navbar-item:focus,a.navbar-item:active{
  background-color: unset!important;
  border: unset!important;
}
.vue-back-to-top{
    bottom: 5%;
    right: 5%;
}
.break-word{
  word-wrap: break-word;
}

.flex-middle{
  display: flex;
  align-items: center;
  justify-content: center;
}
.back-to-top {
  opacity: 0.6;
  color: #fff !important;
  width: 50px;
  height: 50px;
  background: #0D6ACA;
  -webkit-border-radius: 35px;
  -moz-border-radius: 35px;
  border-radius: 35px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.back-to-top:hover{
  opacity: 1;
}
.text-orange{
  color:#FFA800!important;
}

.text-back{
  color:#000;
}
.text-grey{
  color:#C4C4C4;
}

.text {cursor: text;}
.w-100{
  width:100%;
}
.hoverView:hover{
  font-weight:bold;
  color:#0D6ACA!important;
}
.is-hover-under-line:hover{
  text-decoration: underline;
}
.text-underline{
  text-decoration: underline;
}
.h-2-50{
  height: 2.50em!important;
}
.input, .taginput .taginput-container.is-focusable, .textarea, .select select, .file-cta, .file-name, .pagination-previous, .pagination-next, .pagination-link, .pagination-ellipsis,{
  height: 2.50em!important;
}
.input[readonly], .taginput .taginput-container.is-focusable[readonly], .textarea[readonly]{
  background-color: #efefef;
}
.th{
  font-family: 'Kanit', sans-serif!important;
}
.notification .media-left{
  font-size:12px!important;
}
.notification .media{
  display: flex!important;
  align-items: center!important;
}
.notification.is-success.company{
   background-color: #FFA800!important;
}
.notification.is-success {
    // background-color: #0D6ACA!important;
    margin-top: 6rem!important;
}
.border-radius-small{
  border-radius:5px;
}
.bg-grey-lighter{
  background-color:#F1F0F0;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #9a9a9a; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #C1C1C1; 
}
.color-blue{
  color:#0D6ACA;
}
.h-100{
  height:100%!important;
}
.bg-grey{
  background:#f4f4f4;
}
.border-rounded{
  border-radius:10px;
}
.widthfull div.control{
  width: 100%;
}
.widthfull .label{
    color: #0D6ACA;
} 
.widthfull .field:not(:last-child){
  padding-left: 0 !important;
}
.activeinput input{
 box-shadow: 0 0 0 1px #0FB9F4
}
.modalmentor .animation-content{
  width: 500px !important
}
.loading-overlay.is-full-page{
  z-index: 39 !important;
}
.modal .animation-content{
  z-index: 40
}
div.column.is-one-quarter.box-step.pd-5.bgcolor{
min-width: 390px;
    /* height: 109%; */
}
@media screen and (min-width: 769px), print {
  .column.is-four-fifths, .column.is-four-fifths-tablet {
      -webkit-box-flex: 0;
      -ms-flex: none;
      flex: none;
      width: 85% !important;
  }
}

.collapse-content .word-b-all{
 width: 139% !important;
}

.collapse-content .collapse-trigger .word-b-all .icon.is-small{
  right: 27% !important
}

p{

}
    /* right: 103px; */

.button.is-medium {
    font-size: 1.15rem;
}
.menu-list a:hover span.icon .fa-check-circle:before{
         content:"\f304";
         font-size: 16px;
}


.collapse-trigger .word-b-all{
  position:relative;
}

.collapse-trigger .word-b-all .icon.is-small{
  color: white;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
              .word-b-all span.icon{
              color: white !important; font-size: 16px !important; position: absolute; right: -11px;
              }
.menu-list .fa-check-circle:before {
    // content: "\f00c";
    font-size:22px;
}
.basicprofile .upload .upload-draggable{
    height: 240px;
    border:none;
    position: relative;
    display: flex;
    justify-content: center;
}
.basicprofile .upload .upload-draggable::before{
     content: '170 x 170';
    background: rgba(0,0,0,0.25);
    width: 170px;
    position: absolute;
    z-index: 99;
    height: 170px;
    display: flex;
    top: 21px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
}
.upload .upload-draggable .pd-x-10{
      width: 100%;
    position: relative;
}
.upload .upload-draggable .pd-x-10 .is-flex{
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
}
.cursor{
  cursor: pointer;
}

.cursor.has-text-info:hover{color:#0d6aca!important; text-decoration: underline}

.basicprofile .btn-upload{
  display:none;
}
.basicprofile .color-placeholder span{
  color:#0ABA06;
}
.basicprofile .fa-file-upload:before{
      content: "\f030";
      color: #0ABA06;
}
.select:not(.is-multiple):not(.is-loading)::after{
  border-color: #0FB9F4 !important;
}
.select select:focus, .select select.is-focused, .select select:active, .select select.is-active{
      border-color: #0FB9F4 !important;
        box-shadow: 0 0 0 0.125em rgba(15, 185, 244, 0.25) !important;
}
.input:focus, .taginput .taginput-container.is-focusable:focus, .input.is-focused, .taginput .is-focused.taginput-container.is-focusable, .input:active, .taginput .taginput-container.is-focusable:active, .input.is-active, .taginput .is-active.taginput-container.is-focusable, .textarea:focus, .textarea.is-focused, .textarea:active, .textarea.is-active{
  box-shadow: 0 0 0 0.125em rgba(15, 185, 244, 0.25) !important;
}
.input:focus, .taginput .taginput-container.is-focusable:focus, .input.is-focused, .taginput .is-focused.taginput-container.is-focusable, .input:active, .taginput .taginput-container.is-focusable:active, .input.is-active, .taginput .is-active.taginput-container.is-focusable, .textarea:focus, .textarea.is-focused, .textarea:active, .textarea.is-active{
  border-color: #0FB9F4 !important;
}
.button.is-primary{
  background-color: #0FB9F4 !important;
}
.b-checkbox.checkbox input[type=checkbox]:checked + .check {
     background: #0FB9F4 url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:whitesmoke' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E") no-repeat center center !important;
        border-color: #0FB9F4 !important; 
}
.b-checkbox.checkbox:hover input[type=checkbox] + .check{
   border-color: #0FB9F4 !important; 
}

.checkTerm .b-checkbox.checkbox input[type=checkbox]:checked + .check {
     background: #FFA800 url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:whitesmoke' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E") no-repeat center center !important;
        border-color: #FFA800 !important; 
}

#forminput .b-checkbox .control-label{
  word-break: break-word;
      border: 1px solid rgba(139, 139, 139, 0.3);
      border-radius: 5px;
         /* padding: 0.7rem 7rem !important; */
    text-align: center;
    padding: 10px 20px;
}
#forminput [type=checkbox] .check.is-dark{
  display: none;
}
#forminput [type=checkbox] .control-label p.th{
   color: rgba(139, 139, 139, 0.3);
}
#forminput [type=checkbox]:checked .check.is-dark{
  display: inline-block;
}
#forminput [type=checkbox]:checked ~ .control-label{
  display: inline-block;
  color: #0FB9F4 !important;
   border: 1px solid #0FB9F4 ;
   /* padding: 0.7rem 7rem !important; */
   border-radius: 5px;
   word-break: break-word;
   /* width: 100%; */
   
    text-align: center;
    padding: 10px 20px;
}



#forminput .b-checkbox.checkbox input[type=checkbox] + .check{
              border: 3px solid white !important;
              position: absolute;
              display: none;
        }
/* [type=checkbox]:checked ~ .control-label {
  border: 2px solid red;
}   */
#forminput .b-checkbox.checkbox input[type=checkbox]:checked + .check.is-dark {
        border: 3px solid #0FB9F4;
        position: absolute;
        display: block;
        right: -9px;
        top: -10px;
        border-radius: 30px;
        background: #0FB9F4 url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:whitesmoke' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E") no-repeat center center !important;
        border-color: #0FB9F4 !important; 
 }
      
/* latin-ext */
@font-face {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  src: local('Raleway'), local('Raleway-Regular'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptug8zYS_SKggPNyCMIT5lu.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  src: local('Raleway'), local('Raleway-Regular'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptug8zYS_SKggPNyC0ITw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
.fontnormal{
  font-family: 'Raleway';
font-size: 14px;
color: rgba(255, 255, 255, 0.7);;
}
.fontbold{
 font-family: 'Raleway';
  font-weight: bold;
font-size: 14px;
color: white;
}

.signin-page .media-content{
  text-align:center!important;
}

.fontbold2{
font-family: 'Raleway';  
 font-weight: bold !important;
color: white;
font-size: 20px;
transition: all 0.5s;
}

.buttonc{
  background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
  border-radius: 40px;
}
body,html{
  height:100%;
  overflow-y: unset!important;
}
#app {
  font-family: 'Raleway', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #585858;
  height:100%;
}
a.navbar-item:hover, a.navbar-item.is-active, .navbar-link:hover, .navbar-link.is-active{
      background-color: transparent !important;
    color: white !important; 
}
.pd-0{
  padding: 0!important;
}
.pd-1{
  padding: 0.25rem!important;
}
.pd-2{
  padding: 0.5rem!important;
}
.pd-3{
  padding: 0.75rem!important;
}
.pd-4{
  padding: 1rem!important;
}
.pd-5{
  padding: 1.5rem!important;
}

.pd-l-0{
  padding-left: 0!important;
}
.pd-l-1{
  padding-left: 0.25rem!important;
}
.pd-l-2{
  padding-left: 0.5rem!important;
}
.pd-l-3{
  padding-left: 0.75rem!important;
}
.pd-l-4{
  padding-left: 1rem!important;
}
.pd-l-5{
  padding-left: 1.5rem!important;
}
.pd-l-6{
  padding-left: 2rem!important;
}
.pd-l-7{
  padding-left: 2.5rem!important;
}
.pd-l-8{
  padding-left: 3rem!important;
}
.pd-20{
  padding-top:20px!important;
  padding-right:20px!important;
  padding-bottom:20px!important;
  padding-left:20px!important;
}
.pd-b-0{
  padding-bottom:0!important;
}
.pd-b-5{
  padding-bottom: 1rem!important;
}
.pd-x-0{
  padding-left: 0!important;
  padding-right: 0!important;
}
.pd-x-1{
  padding-left: .25rem!important;
  padding-right: .25rem!important;
}
.pd-x-2{
  padding-left: 0.5rem!important;
  padding-right: 0.5rem!important;
}
.pd-x-3{
  padding-left: 0.75rem!important;
  padding-right: 0.75rem!important;
}
.pd-x-4{
  padding-left: 1rem!important;
  padding-right: 1rem!important;
}
.pd-x-5{
  padding-left: 1.25rem!important;
  padding-right: 1.25rem!important;
}
.pd-y-0{
  padding-top: 0!important;
  padding-bottom: 0!important;
}
.pd-y-1{
  padding-top: .25rem!important;
  padding-bottom: .25rem!important;
}
.pd-y-2{
  padding-top:  0.5rem!important;
  padding-bottom:  0.5rem!important;
}
.pd-y-3{
  padding-top: 0.75rem!important;
  padding-bottom: 0.75rem!important;
}
.pd-y-4{
  padding-top: 1rem!important;
  padding-bottom: 1rem!important;
}
.pd-y-5{
  padding-top: 1.25rem!important;
  padding-bottom: 1.25rem!important;
}
.pd-t-4{
  padding-top: 1rem!important;
}
.pd-t-5{
  padding-top: 1.25rem!important;
}
.mg-r-5 {
  margin-right: 5px !important;
}
.mg-r-10 {
  margin-right: 10px !important;
}
.mg-r-20 {
  margin-right: 20px !important;
}
.mg-b-5{
  margin-bottom: 1rem!important;
}
.mg-5px{
  margin-bottom: 5px!important;
}
.mg-b-0{
  margin-bottom:0!important;
}
.mg-0{
  margin:0!important;
}
.mg-1{
  margin:0.25rem!important;
}
.mg-2{
  margin:0.5rem!important;
}
.mg-3{
  margin:0.75rem!important;
}
.mg-4{
  margin:1rem!important;
}
.mg-5{
  margin:1.25rem!important;
}
.mg-y-1{
  margin-top:0.25rem!important;
  margin-bottom:0.25rem!important;
}
.mg-y-2{
  margin-top:0.5rem!important;
  margin-bottom:0.5rem!important;
}
.mg-y-3{
  margin-top:0.75rem!important;
  margin-bottom:0.75rem!important;
}
.mg-y-4{
  margin-top:1rem!important;
  margin-bottom:1rem!important;
}
.mg-y-5{
  margin-top:1.25rem!important;
  margin-bottom:1.25rem!important;
}
.mg-x-auto{
  margin-left:auto!important;
  margin-right:auto!important;
}
.mg-x-1{
  margin-left:0.25rem!important;
  margin-right:0.25rem!important;
}
.mg-x-2{
  margin-left:0.5rem!important;
  margin-right:0.5rem!important;
}
.mg-x-3{
  margin-left:0.75rem!important;
  margin-right:0.75rem!important;
}
.mg-x-4{
  margin-left:1rem!important;
  margin-right:1rem!important;
}
.mg-x-5{
  margin-left:1.25rem!important;
  margin-right:1.25rem!important;
}
.mg-l-0{
  margin-left:0!important;
}
.mg-l-1{
  margin-left:0.25rem!important;
}
.mg-l-2{
  margin-left:0.5rem!important;
}
.mg-l-3{
  margin-left:0.75rem!important;
}
.mg-l-4{
  margin-left:1rem!important;
}
.mg-l-5{
  margin-left:1.25rem!important;
}
.mg-t-0 {
  margin-top: 0px !important;
}
.mg-t-5 {
  margin-top: 5px !important;
}
.mg-t-10 {
  margin-top: 10px !important;
}
.mg-t-15 {
  margin-top: 15px !important;
}
.mg-t-20 {
  margin-top: 20px !important;
}
.mg-t-30 {
  margin-top: 30px !important;
}
.mg-t-40 {
  margin-top: 40px !important;
}
.mg-t-5rem{
  margin-top: 5rem!important;
}
.mg-t-7rem{
  margin-top: 7rem!important;
}
.mg-40{
  margin: 40px!important;
}
.mg-b-3{
  margin-bottom: 5px!important;
}
.align-center{
  align-items: center!important;
}
.fixed-error-msg p{ 
    position: fixed!important;
}
.form-upload .upload-draggable{
    width: 100%!important;
    padding:0.5rem!important;
}
.color-placeholder{
  color:rgba(122, 122, 122, 0.7)
}
.mx-datepicker-popup{
  left: 0 !important;
  top: -309px!important;
}
.mx-input{
  height: 2.50rem!important;
}
.w-60{
  width: 60%!important;
}
.word-b-all{
  word-break: break-all!important;
}

.box-step{
  border-color: white;
}
a.has-text-primary:hover, a.has-text-primary:focus{
  color: white !important;
}
div.control{
    width: 80%;
    display: inline-block;
}
p.help{
    display: inline-block;
        font-size: 0.85rem;
        position: relative;
        top:5px

}
.b-radio.radio:hover input[type=radio] + .check.is-dark{
  border-color: #0FB9F4 !important; 
     
}
.b-radio.radio input[type=radio] + .check{
 border: 2px solid #0FB9F4 !important;
}
.b-radio.radio input[type=radio] + .check.is-dark:before{
      background: #0FB9F4 !important;
}
/* .sidenav  */
.sidenav .b-radio.radio .control-label,.b-checkbox.checkbox .control-label {
    font-size: 15px;
    font-weight: normal;
}

.sidenav .b-radio.radio input[type=radio] + .check{
 border: 1px solid #DADADA !important;
}
.sidenav .b-radio.radio input[type=radio] + .check.is-dark:before{
      background: #DADADA !important;
}
.sidenav .b-radio.radio input[type=radio] + .check:before{
  background: #DADADA;
}
/* .sidenav   */
.basicprofile .mx-datepicker .mx-input-wrapper{
    top: 7px !important;
}
.pd-3{
  padding :0.25rem !important;
}

.field:not(:last-child){
      padding: 0px 6px !important;
}
.form-upload .upload-draggable:hover{
    background: transparent !important;
}
.industindust .control-label ,.industindust .b-checkbox.checkbox{
    width: 100% !important;
}
.industindust .field{
    width: 50%;
}

.signup .help.is-danger,.signin .help.is-danger,.modalmentor .help.is-danger{
  top: 0 !important;
}
.width-max{
  width: 100%!important;
}
.modalmentor div.control{
  float:left;
}
.modalmentor div.control{
  width: 100%;
}
.is-flex-wrap{
  flex-wrap: wrap;
}
.is-justify-center{
  justify-content: center;
}
.is-justify-start{
  justify-content:flex-start;
}
.is-justify-end{
 justify-content: flex-end;
}
.is-justify-around{
  justify-content: space-around;
}
.is-justify-between{
  justify-content: space-between;
}
.is-align-start{
  align-items: flex-start;
}
.is-align-center{
  align-items: center;
}
.is-align-end{
  align-items: flex-end;
}
.is-align-stretch{
  align-items: stretch;
}
.is-align-baseline{
  align-items: baseline;
}
.modalmentor .label{
  text-align: left;
}
.modal-card-body .password{
  padding: 0 !important;
}
.sidenav .b-radio.radio input[type=radio] + .check:before{
      background: #0FB9F4;
}
.sidenav .b-checkbox.checkbox input[type=checkbox] + .check{
  border: 1px solid #DADADA !important;
}
#VuePhoneNumberInput_phone_number{
  margin-left: 0px!important;
}
.error .flex-1 .input-phone-number #VuePhoneNumberInput_phone_number{
  border-color: #ff3860!important;
}
.vs-hidden{
  visibility: hidden;
}
.dp-overfolw-auto .dropdown-menu .dropdown-content{
    max-height: 300px!important;
    overflow-y: auto!important;
}
.auto-filter .field .control.is-small.is-expanded.is-clearfix{
  width: 100%!important;
}
.table-invest .level .level-right .level-item .pagination .pagination-list .pagination-link.is-current {
		background-color: #0FB9F4!important;
		border-color: #0FB9F4!important;
		color: white;
  }
  .transition-2 {
    transition: 2s all ease!important;
  }
  .input-custom .form-group .form-group-inner .form-control{
    -moz-appearance: none;
    -webkit-appearance: none;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 4px;
    -webkit-box-shadow: none;
    box-shadow: none;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 1rem;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(0.375em - 1px);
    padding-left: calc(0.625em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
    position: relative;
    vertical-align: top;
    background-color: white;
    border-color: #dbdbdb;
    color: #363636;
    max-width: 100%;
    width: 100%;
    height: 2.5em !important;
  }
  .input-custom .form-group .form-group-inner .form-control:focus{
    border-color: #0FB9F4 !important;
    box-shadow: none !important;
  }
/* .error .select-country-container .country-selector #VuePhoneNumberInput_country_selector{
  border-color: #ff3860!important;
} */
</style>
<style lang="scss">
@import "~bulma/sass/utilities/_all";
$primary: white;
$primary-invert: findColorInvert($primary);
$twitter: white;
$twitter-invert: findColorInvert($twitter);

$colors: (
    "primary": ($primary, $primary-invert),
    "twitter": ($twitter, $twitter-invert)
);
.mg-r-8{
  margin-right: 8px!important;
}
.mg-r-auto{
  margin-right: auto!important;
}
.mg-l-auto{
  margin-left: auto!important;
}
.nav-color{
  color: #0D6ACA!important;
}
.mh-100{
  max-height: 100%!important;
}
.bd-shadow{
  box-shadow: 0px 5px 5px 0px rgba(237,237,237,1)!important;
}
.text-break{
  word-break:break-all!important;
}
.center-flex{
  display: flex!important;
  justify-content: center!important;
  align-items: center!important;
}

.info-invest.b-tooltip.is-bottom.is-info:before {
    border-bottom: 5px solid #585858!important;
}
.info-invest.b-tooltip.is-info:after {
    background: #585858!important;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

@-webkit-keyframes shake {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

@keyframes shake {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

.shake{
  -webkit-animation-name: shake;
  animation-name: shake;
}
</style>
